export default __webpack_public_path__ + "76e574bfbb37ca8753391fa71624e6f6.svg";